<template>
  <div class="cake">
    <back title="蛋糕"></back>
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/cake/banner.jpg"
    ></landingBanner>
    <div class="content">
      <indexTitle
        title1="免费获取课程学费"
        title2="To get the tuition"
      ></indexTitle>
      <footerForm color="#fff" bag="#a96b04" words="获取学费"></footerForm>
      <indexTitle
        title1="从小白到蛋糕大师"
        title2="轻松玩转N种蛋糕造型"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/cake/part1.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <find></find>
      <indexTitle
        title1="教学作品"
        title2="没有防腐剂、添加剂、只有最清新的香甜"
      ></indexTitle>
    
    <van-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/cake/part2.jpg"
    >
      <template v-slot:loading>
        <van-loading size="20" color="#fff" />
      </template>
    </van-image>
    <find></find>
    <indexTitle
      title1="教学环境"
      title2="高逼格欧式装修环境，比网红还网红"
    ></indexTitle>
    <van-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/cake/part3.jpg"
    >
      <template v-slot:loading>
        <van-loading size="20" color="#fff" />
      </template>
    </van-image>
    <find></find>
    <indexTitle
      title1="师资力量"
      title2="资深西点讲师，多年经验倾囊相授"
    ></indexTitle>
    <van-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/cake/part4.jpg"
    >
      <template v-slot:loading>
        <van-loading size="20" color="#fff" />
      </template>
    </van-image>
    <indexTitle title1="学员福利" title2="优厚教学福利，请接好"></indexTitle>
    <van-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/cake/part5.jpg"
    >
      <template v-slot:loading>
        <van-loading size="20" color="#fff" />
      </template>
    </van-image>
    <find></find>
    <indexTitle
      title1="热门专业简介"
      title2="HOT PROFESSIONAL PROFILE"
    ></indexTitle>
    <van-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/cake/part6.jpg"
    >
      <template v-slot:loading>
        <van-loading size="20" color="#fff" />
      </template>
    </van-image>
     <indexTitle
        title1="免费获取课程学费"
        title2="To get the tuition"
      ></indexTitle>
      <footerForm color="#fff" bag="#a96b04" words="点击获取学费报价"></footerForm>
      </div>
      <foot></foot>
  </div>
</template>

<script>
export default {
  components: {
    back: () => import("@/components/head/back"),
    landingBanner: () => import("@/components/common/landing-banner"),
    indexTitle: () => import("@/components/common/indexTitle"),
    footerForm: () => import("@/components/form/footerForm"),
    find: () => import("@/components/common/find"),
    foot: () => import("@/components/foot/foot"),
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.cake {
  margin-top: 50px;
}
.content {
  padding: 10px;
}
</style>
